export const ClientIdSpotify = "6b81aee6295f4241b1442fd768e26a0e";
export const FireBaseCollectionID = "uq5qdkdYhTG3mbdaJtiD";
export const heroApiENDPOINT = "https://superheroapi.com/api/"
export const HeroApiAccessToken = "10216578763606325/";
export const heroApihost = "superhero-search.p.rapidapi.com";
export const HeroApiAccessKey = "082c139e33msh442d3896dd27c71p1736a5jsnd79299b534be";
export const REACT_APP_CLIENT_ID='3d0eb5171e7145caabc9f896ee7ef878'
export const REACT_APP_AUTHORIZE_URL='https://accounts.spotify.com/authorize'
export const REACT_APP_REDIRECT_URL='http://www.simonsundin.com/heroify/choosehero'
export const scopes = "&scope=user-read-private user-library-modify playlist-modify-public user-top-read playlist-modify-public"